import React, { useState } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import { z } from 'zod';
import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import axiosClient from '@/utils/axiosClient';
import Modal from '../Modals/Modal';

const formSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
});

const AddAccountModal = NiceModal.create(() => {
  const queryClient = useQueryClient();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: '',
    },
  });

  const modal = useModal('add-account-modal');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { handleSubmit } = form;

  async function onSubmit(data: z.infer<typeof formSchema>) {
    setIsSubmitting(true);

    try {
      const response = await axiosClient.post(`v1/accounts`, {
        name: data.name,
      });
      if (response.status === 201) {
        queryClient.clear();
        window.location.href = '/';
      } else {
        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
    }
  }

  return (
    <Modal
      modal={modal}
      title="Create a new account"
      description="Create new accounts and organize your calls in a better way."
    >
      <Form {...form}>
        <form onSubmit={handleSubmit(onSubmit)} className="w-full">
          <div className="flex items-end gap-2">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <div className="w-full">
                  <FormItem>
                    <FormLabel>New Account</FormLabel>
                    <FormControl>
                      <Input placeholder="Enter the name of your new account" autoComplete="off" {...field} />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                </div>
              )}
            />
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Saving...' : 'Add Account'}
            </Button>
          </div>
        </form>
      </Form>
    </Modal>
  );
});

export default AddAccountModal;
